import MenuItem from "../../models/MenuItem";

interface MenuItemProps {
  item: MenuItem;
}

const FALLBACK_MENU_IMAGE = "/aak-logo-192x192.png";

function MenuItemComponent({ item }: MenuItemProps) {
  return (
    <div 
    className="col-12 col-md-6 mb-4"
    data-testid="featured-menu-item">
      <div className="d-flex p-3 h-100">
        <div className="ms-2 me-3 d-flex align-items-start justify-content-center flex-shrink-0">
          <img
            src={item.imgUrl || FALLBACK_MENU_IMAGE}
            alt={item.name}
            loading="lazy"
            className="img-fluid rounded-3"
            style={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
            }}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = FALLBACK_MENU_IMAGE;
            }}
          />
        </div>

        <div className="flex-grow-1">
          <div className="d-flex justify-content-between gap-3">
            <h4 className="mb-2">{item.name}</h4>
            <strong className="text-nowrap">${item.price.toFixed(2)}</strong>
          </div>

          <p className="mb-0" style={{ whiteSpace: "pre-line" }}>
            {item.description}
          </p>
        </div>
      </div>
    </div>
  );
}

export default MenuItemComponent;